/**
 * @generated SignedSource<<dd440e494ba042ea61369d8d1149a0e0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedMobileRelatedItem_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useFavoritesItem_user">;
  readonly " $fragmentType": "SharedMobileRelatedItem_user";
};
export type SharedMobileRelatedItem_user$key = {
  readonly " $data"?: SharedMobileRelatedItem_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedMobileRelatedItem_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedMobileRelatedItem_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useFavoritesItem_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "18a23da223f548e21b853efa6c4f6d0d";

export default node;
